import Youtube from './Youtube';
import Vimeo from './Vimeo';

export default class Video {
  constructor(el) {
    this.el = el;
    this.platform = el.getAttribute('data-video').trim();
    this.placeholder = el.querySelector('[data-video-placeholder]');
    this.playButton = el.querySelector('[data-video-play-button]');
    this.onPlayClick = this._onPlayClick.bind(this);

    this.video = null;

    switch (this.platform) {
      case 'youtube':
        this.video = new Youtube(el.querySelector('[data-youtube]'));
        break;
      case 'vimeo':
        this.video = new Vimeo(el.querySelector('[data-vimeo]'));
        break;
      default:
        this.video = null;
        break;
    }

    if (this.playButton) {
      this.playButton.addEventListener('click', this.onPlayClick);
    }
  }

  _onPlayClick() {
    this.el.classList.add('video-loading');

    this.video.play()
      .then(() => {
        this.el.classList.add('video-transitioning');

        setTimeout(() => {
          this.el.classList.remove('video-loading');
          this.el.classList.remove('video-transitioning');
          this.el.classList.add('video-playing');
        }, 200);
      });
  }

  unload() {
    if (this.playButton) {
      this.playButton.removeEventListener('click', this.onPlayClick);
    }

    if (this.video) {
      this.video.unload();
    }
  }
}
